import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const GaragePage = lazyPage(() => import("./pages/GaragePage"), "GaragePage");
const AddVehiclePage = lazyPage(() => import("./pages/AddVehiclePage"), "AddVehiclePage");

export const vehiclesModule: WebModule = {
  id: "vehicles",
  nav: null,
  routes: [
    { path: "/vehicles", element: <GaragePage /> },
    { path: "/vehicles/add", element: <AddVehiclePage /> },
  ],
  publicRoutes: [],
};
